import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Directory() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [specialists, setSpecialists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/specialists")
      .then((r) => setSpecialists(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="directory-page">
      <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-gold mb-2">Verified Network</p>
      <h1 className="font-serif text-3xl font-semibold text-navy mb-10">Specialist Directory</h1>

      {loading ? (
        <p className="font-mono text-xs text-navy/40 tracking-widest" data-testid="directory-loading">LOADING…</p>
      ) : (
        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-px bg-navy/10 border border-navy/10" data-testid="directory-grid">
          {specialists.map((s) => (
            <div key={s.id} className="bg-white p-8 flex flex-col" data-testid={`specialist-card-${s.id}`}>
              <p className="font-serif text-xl font-semibold text-navy">
                {s.name}
                {s.id === user?.id && (
                  <span className="ml-2 font-mono text-[9px] tracking-[0.2em] uppercase text-gold align-middle">You</span>
                )}
              </p>
              <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-gold mt-2">{s.specialty}</p>
              <p className="text-sm text-navy/60 mt-4 flex-1">{s.organization}</p>
              <div className="mt-6 pt-5 border-t border-navy/10 flex items-center justify-between gap-3">
                <span className="font-mono text-[10px] text-navy/40">{s.gmc_number}</span>
                {s.id !== user?.id && (
                  <button
                    onClick={() => navigate(`/portal/referrals?to=${s.id}`)}
                    data-testid={`refer-button-${s.id}`}
                    className="bg-navy text-ivory font-mono text-[10px] tracking-[0.2em] uppercase px-4 py-2.5 hover:bg-gold hover:text-navy transition-colors"
                  >
                    Refer Patient
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
